import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {DateTime} from 'luxon';
import {Utils} from '@astek/utils';

@Component({
  selector: 'xp-sensor-order-shipping-dialog',
  templateUrl: './sensor-order-shipping-dialog.component.html',
  styleUrls: [
    '../../crud.common.scss',
    '../../../shared/components/dialog.common.scss',
    './sensor-order-shipping-dialog.component.scss',
  ],
})
export class SensorOrderShippingDialogComponent {

  public readonly formGroup = this._formBuilder.group({
    shippedAt: new FormControl<DateTime | null>(null, [Validators.required.bind(Validators)]),
  });

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _dialogRef: MatDialogRef<SensorOrderShippingDialogComponent>,
  ) {

  }

  public get maxDate(): string {
    return DateTime.now().toISODate();
  }

  public onSubmit(): void {
    if (this.formGroup.invalid || Utils.isNullOrUndefined(this.formGroup.controls.shippedAt.value)) {
      return;
    }
    this._dialogRef.close(this.formGroup.controls.shippedAt.value.toISODate());
  }

}
